module.exports = __webpack_public_path__ + "img/company-rucika.c650bbb8.png";